
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmerblanketmanu() {



  const cardData =
  {
    keyword: 'Patient Warmer Blanket Manufacturers',
    heading: 'Pharmacle Health Care Private Limited: Patient Warmer Blanket Manufacturers',
    headingDescription: 'Pharmacle Health Care Private Limited is a trusted name among Patient Warmer Blanket Manufacturers, delivering high-performance thermal care solutions for hospitals and surgical centers. Our patient warmer blankets are designed to provide uniform, controlled heat, helping prevent perioperative hypothermia and ensuring patient comfort and safety. Built with advanced technology and high-quality materials, our warming blankets are user-friendly, durable, and ideal for various clinical environments. Choose Pharmacle Health Care for reliable patient warmer blankets that enhance temperature management and support better clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Top Patient Warmer Blanket Manufacturers for Clinical Excellence",
    "description": "Pharmacle Health Care is a trusted name among patient warmer blanket manufacturers, offering high-efficiency thermal blankets that ensure consistent and safe temperature regulation for patients undergoing surgery or in post-operative recovery. Our warming blankets are designed to minimize hypothermia risks and promote faster healing."
  },
  {
    "title": "Leading Manufacturer of Advanced Patient Warmer Blankets",
    "description": "As one of the leading manufacturers of patient warmer blankets, Pharmacle Health Care delivers cutting-edge solutions that help healthcare professionals maintain normothermia throughout surgical and critical care procedures. Our products are engineered with advanced thermal distribution technology for maximum patient comfort and safety."
  },
  {
    "title": "Reliable Patient Warmer Blanket Solutions for Hospitals and Clinics",
    "description": "Pharmacle Health Care’s patient warmer blankets are crafted to meet the stringent demands of modern healthcare settings. Designed with precision and safety in mind, our blankets help reduce surgical complications, lower infection rates, and enhance overall patient outcomes. We are a preferred choice for hospitals and medical centers nationwide."
  },
  {
    "title": "High-Quality Patient Warmer Blankets Manufactured with Innovation",
    "description": "At Pharmacle Health Care, we manufacture high-quality patient warmer blankets that integrate innovative heating elements and soft, hypoallergenic materials to ensure optimal thermal comfort. Our blankets support surgical teams in maintaining consistent body temperatures, crucial for positive procedural results and recovery."
  },
  {
    "title": "Patient Warming Blankets Manufacturer Focused on Patient Safety",
    "description": "Patient safety is at the heart of every product we manufacture. Pharmacle Health Care’s warmer blankets are developed using advanced temperature control systems to reduce the risk of hypothermia, making them ideal for use during surgeries, intensive care, and emergency interventions."
  },
  {
    "title": "Trusted Supplier of Patient Warmer Blankets for Medical Use",
    "description": "Pharmacle Health Care is a reliable supplier of patient warmer blankets that meet global quality and safety standards. Our blankets are widely used across operating rooms, ICUs, and recovery areas, ensuring patients are kept at a stable temperature during their most vulnerable moments."
  },
  {
    "title": "Buy Durable and Effective Patient Warmer Blankets",
    "description": "Pharmacle Health Care offers durable and efficient patient warmer blankets, available in a range of configurations to suit various medical procedures. With our commitment to quality, healthcare providers can rely on us for long-lasting and easy-to-use warming solutions."
  },
  {
    "title": "Patient Warmer Blanket Manufacturer Supporting Surgical Success",
    "description": "With our specialized patient warmer blankets, Pharmacle Health Care contributes to safer surgeries and faster recoveries. We supply hospitals with technologically advanced warming blankets that help in achieving better surgical outcomes through effective thermal support."
  },
  {
    "title": "Customizable Patient Warming Blankets from Leading Manufacturer",
    "description": "Pharmacle Health Care provides customizable patient warming blanket solutions tailored to diverse surgical and post-surgical requirements. Our blankets combine smart design with proven thermal efficacy, ensuring patients remain warm and protected at every stage of care."
  },
  {
    "title": "Explore the Best Patient Warmer Blankets – Manufactured by Experts",
    "description": "Discover Pharmacle Health Care’s range of expertly manufactured patient warmer blankets that meet the demands of modern-day surgical and intensive care units. Our products are trusted for their reliability, ease of use, and effectiveness in maintaining critical body temperatures."
  }
],

"services": [
    {
        "name": "Patient Warmer Blanket Manufacturers",
        "description": "Pharmacle Health Care is a leading manufacturer of patient warmer blankets, designed to provide effective thermal regulation during medical procedures. These blankets help prevent hypothermia, ensuring patients remain at a safe and comfortable temperature throughout surgeries, recovery, and critical care. Our patient warmer blankets are made with high-quality materials to offer both reliability and comfort, making them an essential part of medical care in hospitals and clinics."
    },
    {
        "name": "Medical Warming Blanket Suppliers",
        "description": "We supply medical warming blankets across India, ideal for regulating body temperature during surgeries, recovery, and emergency medical treatments. These blankets are designed to keep patients warm, preventing the adverse effects of hypothermia, while promoting faster recovery and overall comfort. Our medical warming blankets are trusted by hospitals and healthcare institutions for their reliability and effectiveness."
    },
    {
        "name": "Surgical Warmer Blanket Manufacturers",
        "description": "Pharmacle Health Care manufactures surgical warmer blankets that are specifically designed to maintain body temperature during surgical procedures. These blankets provide consistent heat, which is crucial for preventing hypothermia and ensuring patient safety. Our surgical warmer blankets are easy to use, highly effective, and help improve surgical outcomes by maintaining optimal body temperature throughout the operation."
    },
    {
        "name": "Hospital Patient Warming Blankets",
        "description": "We offer high-quality hospital patient warming blankets that are essential for ensuring safe temperature regulation in medical environments. These blankets are designed to be used in operating rooms, recovery areas, and critical care units to prevent hypothermia, increase patient comfort, and reduce recovery time. Our hospital patient warming blankets are known for their durability and effectiveness in diverse healthcare settings."
    },
    {
        "name": "Patient Thermal Blankets",
        "description": "Our patient thermal blankets are designed to offer controlled and consistent heating to maintain a patient's body temperature during medical treatments. These blankets are essential for preventing temperature-related complications and improving recovery rates. Whether used during surgery, recovery, or critical care, our patient thermal blankets ensure a safe and comfortable environment for patients."
    },
    {
        "name": "Patient Heating Blankets",
        "description": "Pharmacle Health Care provides patient heating blankets designed to regulate body temperature and prevent hypothermia during medical procedures. These blankets are particularly useful in surgeries, post-operative care, and emergency treatments, ensuring the patient remains comfortable and safe throughout the process. Our patient heating blankets are reliable and easy to use, offering the best in comfort and safety for patients."
    },
    {
        "name": "Reusable Warming Blankets for Hospitals",
        "description": "We offer reusable warming blankets for hospitals, designed to be durable, efficient, and eco-friendly. These blankets provide effective and reliable warmth to patients during surgeries and recovery, helping to reduce the risks associated with hypothermia. With high-quality materials, our reusable warming blankets are an essential asset for healthcare providers seeking a cost-effective, sustainable solution."
    },
    {
        "name": "Disposable Patient Warmer Blankets",
        "description": "Our disposable patient warmer blankets are designed for single-use, providing a convenient and hygienic option for maintaining body temperature during medical procedures. These blankets are ideal for use in emergency situations or high-volume environments where cleanliness and convenience are top priorities. Our disposable warmer blankets are designed to prevent hypothermia and ensure patient comfort during surgeries or recovery."
    },
    {
        "name": "Blanket-Style Warming System",
        "description": "The blanket-style warming system from Pharmacle Health Care is designed to offer a comprehensive solution for maintaining patient temperature in medical settings. This system features an advanced design that allows for easy coverage and temperature control, ensuring that patients remain warm and comfortable during surgery, post-operative recovery, or critical care. Our blanket-style warming systems are highly effective and reliable, helping to optimize patient safety and comfort."
    }
],
"tableData": [
    ["- Patient Warmer Blanket Manufacturers", "- Medical Warming Blanket Suppliers"],
    ["- Surgical Warmer Blanket Manufacturers", "- Hospital Patient Warming Blankets"],
    ["- Patient Thermal Blankets", "- Patient Heating Blankets"],
    ["- Reusable Warming Blankets for Hospitals", "- Disposable Patient Warmer Blankets"],
    ["- Blanket-Style Warming System"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As top Patient Warmer Blanket Manufacturers, we offer advanced warming blankets that ensure precise temperature control during medical procedures. Our blankets are designed to prevent hypothermia, providing reliable warmth and enhancing patient safety across healthcare facilities."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a range of Patient Warmer Blankets, designed to keep patients warm and comfortable during medical treatments. Our solutions are customized to meet the unique needs of healthcare providers, ensuring comfort and safety during critical procedures."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warmer Blankets are manufactured to the highest standards of quality and durability, ensuring long-lasting performance. Each blanket is rigorously tested to maintain optimal performance and reliability in healthcare settings."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are our top priorities. Our Patient Warmer Blankets provide gentle and controlled warmth to help prevent temperature-related complications during surgeries and other medical procedures, ensuring patient safety at all times."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warmer Blankets are versatile and adaptable to different healthcare settings. Whether for use in operating rooms, recovery areas, or patient wards, we provide flexible solutions tailored to the specific needs of healthcare providers."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Designed for seamless integration, our Patient Warmer Blankets can easily be incorporated into existing medical systems. They are easy to deploy, ensuring that medical procedures are not disrupted while providing essential warmth to patients."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation to help healthcare facilities select the best Patient Warmer Blankets for their needs. Our team provides ongoing support and maintenance to ensure optimal performance and reliability of the blankets."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are our primary concern. Our Patient Warmer Blankets are designed to prevent temperature-related complications and ensure that patients are warm and comfortable throughout their medical treatments."
    }
]

















  }

  const faqData = [
    {
      question: "Who are the top Patient Warmer Blanket manufacturers?",
      answer: "Pharmacle Health Care Private Limited is recognized as one of the top Patient Warmer Blanket manufacturers, offering high-quality solutions designed to maintain patient body temperature effectively during surgeries and critical care."
    },
    {
      question: "What makes Pharmacle Health Care’s Patient Warmer Blankets effective?",
      answer: "Pharmacle Health Care’s warmer blankets are engineered for uniform heat distribution, comfort, and safety. They work in conjunction with Forced Air Warming Systems to prevent hypothermia in surgical and post-operative settings."
    },
    {
      question: "Are Pharmacle Health Care’s Patient Warmer Blankets suitable for all medical procedures?",
      answer: "Yes, the warmer blankets are versatile and suitable for various procedures, including general surgery, orthopedics, and critical care, where maintaining normothermia is crucial."
    },
    {
      question: "Can Pharmacle Health Care supply Patient Warmer Blankets across India?",
      answer: "Yes, Pharmacle Health Care Private Limited provides nationwide delivery, ensuring hospitals and clinics across India have access to their reliable patient warming solutions."
    },
    {
      question: "Does Pharmacle Health Care provide support for its Patient Warmer Blankets?",
      answer: "Absolutely. Pharmacle Health Care offers comprehensive support, including product guidance, user training, and maintenance to ensure the efficient use of their Patient Warmer Blankets."
    }
  ];
  
  const testimonialsData = [
    {
      text: "Pharmacle Health Care’s Patient Warmer Blankets have been a game-changer in our operating rooms. They’re effective, safe, and easy for our team to use.",
      name: "Dr. Suman Verma, Apex Hospital"
    },
    {
      text: "The quality of the Patient Warmer Blankets from Pharmacle Health Care is excellent. We’ve seen a noticeable improvement in patient outcomes during and after surgeries.",
      name: "Metro Care Surgical Center"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warmer Blanket Manufacturers",
    "description": "Leading Patient Warmer Blanket Manufacturers offering medical warming blankets, surgical warmer blankets, and both reusable and disposable solutions for hospitals. Enhance patient care with high-quality thermal warming blankets.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1698"
    }
  };
  
 
  

  return (
    <div>

<Helmet>
  <title>Patient Warmer Blanket Manufacturers | Hospital Surgical Warming Solutions</title>
  <meta
    name="description"
    content="India’s trusted Patient Warmer Blanket Manufacturers offering reusable and disposable warming blankets for hospitals, OT, ICUs, and surgical care. Enhance recovery with thermal warmth. Call +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warmer Blanket Manufacturers, Surgical Warming Blanket Suppliers, Hospital Thermal Blankets, Medical Patient Warmer Blanket India, Disposable Surgical Warmers, Reusable Operating Room Blankets, ICU Thermal Warming Solutions, Heating Blankets for Surgery, OT Patient Warming Blanket, Blanket Warming System"
  />
  <meta property="og:title" content="Top Patient Warmer Blanket Manufacturers | Surgical Heating Blankets India" />
  <meta property="og:description" content="Trusted source for hospital-grade patient warming blankets in India. Disposable & reusable options with high thermal efficiency. Contact us today." />
  <meta property="og:image" content="https://wallabieswarmcares.com/path-to-blanket-image.jpg" />
  <meta property="og:url" content="https://wallabieswarmcares.com/patient-warmer-blankets" />
  <meta property="og:type" content="product" />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>







 {/* <Helmet>
    <title>Patient Warmer Blanket Manufacturers | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Top Patient Warmer Blanket Manufacturers supplying medical and surgical warming blankets, including reusable and disposable options for hospitals. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warmer Blanket Manufacturers, Medical Warming Blanket Suppliers, Surgical Warmer Blanket Manufacturers, Hospital Patient Warming Blankets, Patient Thermal Blankets, Patient Heating Blankets, Reusable Warming Blankets for Hospitals, Disposable Patient Warmer Blankets, Blanket-Style Warming System"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
   */}

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/46.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmerblanketmanu;